const AssetIcon = () => {
    return (
        <svg
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 122.88 94.06"
            // style={{
            //     enableBackground: 'new 0 0 122.88 94.06'
            // }}
            xmlSpace="preserve">
            <style type="text/css" />
            <g>
                <path
                    className="st0"
                    d="M3.12,0h101.16c1.72,0,3.13,1.4,3.13,3.12v7.99h-6.63V8.64c0-1.52-1.23-2.76-2.76-2.76H9.4l0,0l0,0 c-1.52,0-2.77,1.24-2.76,2.76v52.55c0,1.51,1.24,2.76,2.76,2.76h67.91V77H3.12C1.4,77,0,75.59,0,73.87V3.12C0,1.4,1.4,0,3.12,0 L3.12,0L3.12,0L3.12,0z M90.52,21.33h28.46c2.15,0,3.91,1.76,3.91,3.91v57.14c0,2.15-1.76,3.91-3.91,3.91H90.52 c-2.15,0-3.91-1.76-3.91-3.91V25.23C86.61,23.09,88.37,21.33,90.52,21.33L90.52,21.33L90.52,21.33z M114.35,37.5h2.83v1.62h-2.83 V37.5L114.35,37.5L114.35,37.5z M104.74,70.11c2.34,0,4.25,1.9,4.25,4.25s-1.9,4.25-4.25,4.25c-2.34,0-4.25-1.9-4.25-4.25 C100.5,72.02,102.4,70.11,104.74,70.11L104.74,70.11L104.74,70.11z M91.9,33.8h25.69c0.45,0,0.81,0.37,0.81,0.81v4.42 c0,0.45-0.37,0.81-0.81,0.81H91.9c-0.45,0-0.81-0.37-0.81-0.81v-4.42C91.09,34.17,91.45,33.8,91.9,33.8L91.9,33.8L91.9,33.8z M67.88,81.31c0.07,4.9,2.1,9.3,7.57,12.75H33.22c4.38-3.17,6.33-7.02,6.31-12.75H67.88L67.88,81.31z M53.71,66.47 c2.22,0,4.01,1.8,4.01,4.01s-1.8,4.01-4.01,4.01s-4.01-1.79-4.01-4.01S51.49,66.47,53.71,66.47L53.71,66.47L53.71,66.47z"
                />
            </g>
        </svg>
    )
}

export default AssetIcon
